import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Form, Alert, Row, Col,
} from 'antd';
import {
  Field, reduxForm, reset, SubmissionError,
} from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { autobind } from 'core-decorators';
import { getP, PropType as PolygotPropType } from 'redux-polyglot';
import { getCurrentUser, saveUser } from 'actions/user';
import { TextInput } from '../inputs';


class Password extends Component {
  @autobind
  handleSave(values) {
    const { dispatch, p } = this.props;
    return dispatch(saveUser('me', {
      password: values.password,
      current_password: values.current_password,
    })).then(() => dispatch(getCurrentUser()))
      .then(() => dispatch(reset('password')))
      .catch((action) => {
        if (action.payload.response && action.payload.response.data) {
          const msg = ((errorCode) => {
            if (errorCode === 'INVALID_CREDENTIALS') {
              return p.t('errors.invalid_credentials');
            }
            return p.t('errors.server_error');
          })(action.payload.response.data.result.errorCode);

          throw new SubmissionError({ _error: msg });
        }
        throw new SubmissionError({ _error: p.t('errors.server_error') });
      });
  }

  render() {
    const {
      p,
      handleSubmit,
      submitting,
      error,
    } = this.props;

    return (
      <Form onSubmit={handleSubmit(this.handleSave)}>
        <h1>{p.tt('password')}</h1>
        <Row>
          <Col span={12}>
            <Field
              component={TextInput}
              placeholder=""
              name="current_password"
              type="password"
              label={p.tt('current_password')}
            />
            <Field
              component={TextInput}
              placeholder=""
              name="password"
              type="password"
              label={p.tt('new_password')}
            />
            <Field
              component={TextInput}
              placeholder=""
              name="confirm_password"
              type="password"
              label={p.tt('confirm_password')}
            />
            {error && !submitting && <Alert message={error} type="error" style={{ margin: '16px 0 16px 0' }} />}
            <div className="text-right">
              <Button
                type="primary"
                loading={submitting}
                disabled={submitting}
                htmlType="submit"
              >
                {p.tt('save')}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    );
  }
}

Password.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  p: PolygotPropType,
  dispatch: PropTypes.func,
  error: PropTypes.any,
};

export default compose(
  connect(state => ({
    p: getP(state),
  })), reduxForm({
    form: 'password',
    enableReinitialize: true,
    validate: (values, { p }) => {
      const errors = {};
      if (!values.current_password) {
        errors.current_password = p.t('validation.empty_password');
      }
      if ((values.password || '').length < 6) {
        errors.password = p.t('validation.small_password');
      }
      if (values.password !== values.confirm_password) {
        errors.confirm_password = p.t('validation.confirm_password');
      }
      return errors;
    },
  }),
)(Password);
